<template>
  <view-page
      :button-access="componentAccess"
      :baseRoute='baseRoute'
      :entity='entity'
      :model-entity="modelEntity"
      :page-title="setPageTitle"
  >
    <template v-slot="{ model }">
      <commercial-claim-form
          v-if="model.id"
          readonly v-model="model"
          card-title="Details"
      />
    </template>

    <template v-slot:extra-button="{ model }">
      <vs-button
          v-if="model"
          class="mt-2 ml-4"
          color="light"
          @click="openEnableAlert(model)"
      >
        {{ model.IsEnabled ? "Deactivate" : "Activate" }}
      </vs-button>
    </template>
  </view-page>
</template>

<script>

import CommercialClaimForm from "@/views/pages/commercial-claims-ipr/CommercialClaimForm";
import ViewPage from "@/views/components/Views/ViewPage";
import NotificationMixin from '../../../components/mixins/NotificationMixin';
import EnablePublishMixin from '../../../components/mixins/EnablePublishMixin';

export default {
  name: "CommercialClaimDetails",
  components: {
    CommercialClaimForm,
    ViewPage,
  },
  mixins: [NotificationMixin, EnablePublishMixin],
  data() {
    return {
      baseRoute:'commercial-claims-ipr',
      entity:'Commercial Claim',
      modelEntity: this.$api.commercialClaimsIpr,
      componentAccess: {
        canEdit: {
          route: 'commercial-claims-ipr.edit',
          access: false,
        },
        canDelete: {
          route: 'commercial-claims-ipr.delete',
          access: false,
        },
        canRestore: {
          route: 'commercial-claims-ipr.restore',
          access: false,
        },
      }
    };
  },
  methods: {
    setPageTitle(params) {
      if (!params.CommercialClaimName) {
        return '';
      }
      const name = params.CommercialClaimName || '';
      return "Commercial Claim: " + name;
    }
  }
};
</script>

<style scoped>

</style>
